import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type BillingInterval = 'month' | 'year';

type Props = {
  value: BillingInterval;
  onChange: (value: BillingInterval) => void;
};

const handleToggleChange =
  (onChange: (value: BillingInterval) => void) => (_event: unknown, next: BillingInterval | null) => {
    if (next) {
      onChange(next);
    }
  };

export const BillingIntervalToggle = ({ value, onChange }: Props) => {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup exclusive value={value} onChange={handleToggleChange(onChange)} size="small">
      <ToggleButton value="month">{t('subscription.billingInterval.monthly')}</ToggleButton>
      <ToggleButton value="year">{t('subscription.billingInterval.annual')}</ToggleButton>
    </ToggleButtonGroup>
  );
};
